import { render, staticRenderFns } from "./ModeloValorTipo.vue?vue&type=template&id=3e06050d&"
import script from "./ModeloValorTipo.vue?vue&type=script&lang=js&"
export * from "./ModeloValorTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports